/* eslint-disable react/require-default-props */
import React, { ReactElement, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthentication } from '../context/AuthenticationProvider';

export interface SignOutOidcFragmentProps {
  redirectMessage?: string;
  navigate?: (path: string) => void;
  isPopup?: boolean;
}

export const SignOutOidcFragment = ({
  redirectMessage,
  navigate: navigateFn,
  isPopup = false,
}: SignOutOidcFragmentProps): ReactElement => {
  const { t } = useTranslation('common');
  const history = useHistory();
  const { signoutRedirectCallback, signoutPopupCallback } = useAuthentication();
  const nav = useMemo(
    () => navigateFn || ((path: string) => history.replace(path)),
    [history, navigateFn],
  );

  useEffect(() => {
    async function signoutAsync(): Promise<void> {
      const callbackFunc = isPopup ? signoutPopupCallback : signoutRedirectCallback;
      if (callbackFunc) {
        await callbackFunc();
        nav('/');
      }
    }
    signoutAsync();
  }, [isPopup, nav, signoutRedirectCallback, signoutPopupCallback]);

  return <h1>{redirectMessage || t('authentication.redirecting', 'Redirecting...')}</h1>;
};

export default SignOutOidcFragment;
